import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs'

import { CustomDropdown } from '../utilites'
import { cashBoxService } from '../../services/cashbox-service'

import { messages } from '../../helpers/messages'
import { couponType } from '../../helpers/data-constants'

import './department-edit.scss'
import '../../assets/styles/components/_tables.scss'
import '../../assets/styles/components/_collapse.scss'

import LockIcon from '../../assets/icons/lock.svg'
import DepartmentEditLoader from './Loader/DepartmentEditLoader';
import CouponsTabPanel from "./components/CouponsTabPanel";
import DepartmentTabInfo from "./components/DepartmentTabInfo";

class DepartmentEdit extends Component {

  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      error: null,
      inactiveCheck: false,
      showModalDepartmentEdit: false,
      showModalCouponAdd: false,
      showModalCouponEdit: false,
      showModalCouponCopy: false,
      allChecked: false,
      modalMode: null,
      tabIndex: 0
    };
    this.changeModalState = this.changeModalState.bind(this);
    this.onCashBoxEdit = this.onCashBoxEdit.bind(this);
    this.loadCashBox = this.loadCashBox.bind(this);
    this.loadCashBoxCoupons = this.loadCashBoxCoupons.bind(this);
    this.changeCashBoxState = this.changeCashBoxState.bind(this);
    this.updateCashBox = this.updateCashBox.bind(this);
    this.handleInactiveCheck = this.handleInactiveCheck.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleCouponChange = this.handleCouponChange.bind(this);
    this.handleActivate = this.handleActivate.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleOnCouponCheck = this.handleOnCouponCheck.bind(this);
    this.handleOnAllCouponCheck = this.handleOnAllCouponCheck.bind(this);
    this.selectTab = this.selectTab.bind(this);
  }

  get isAnnuity() {
    return this.state.tabIndex === 1 && this.hasAnnuityFeature();
  }

  hasAnnuityFeature = () => this.props.successFeatures['deal.annuity'];

  componentDidMount() {
    this.loadCashBox(!this.state.inactiveCheck);
  }

  loadCashBox(active = true, ind) {
    let tabValue = couponType.SHORT_TERM;
    if (this.isAnnuity) {
      tabValue = `${couponType.ANNUITY},${couponType.ANNUITY_HYBRID}`;
    }
    this.setState({
      loading: true,
      error: null
    })
    let cashBoxId = this.props.match.params.id;
    cashBoxService.getCashBox(cashBoxId, active, tabValue).then((response) => {
      this.setState({
        cashBox: response.data.cashBox,
        loading: false
      })
      this.loadCashBoxCoupons(cashBoxId);

    });
  }

  loadCashBoxCoupons(cashBoxId) {

    cashBoxService.getCashBoxCoupons(cashBoxId, {couponTypes: couponType.SHORT_TERM}).then((response) => {
      let cashBox = this.state.cashBox;
      if (cashBox?.coupons.length > 1) {
        cashBox.coupons.sort((a, b) => a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1)
        cashBox.coupons.forEach((coupon) => {
          coupon.rows = response.data.coupons[coupon.id];
          coupon.checked = false;
        })
      }
      this.setState({
        cashBox: cashBox,
        loading: false
      })
    });
  }

  changeModalState(name, state) {
    this.setState({
      [name]: state,
      error: null
    })
  }

  selectTab (ind) {
    this.setState({ tabIndex: ind }, () => {
      this.loadCashBox(!this.state.inactiveCheck, ind);
    });
  };

  updateCashBox(entity, onSuccess) {
    const data = {
      ...entity,
      leaderId: entity.leaderId?.value ? entity.leaderId.value : entity.leaderId,
      chiefAccountantId: entity.chiefAccountantId?.value ? entity.chiefAccountantId.value : entity.chiefAccountantId,
      accountantId: entity.accountantId.value ? entity.accountantId.value : entity.accountantId,
      seniorCommodityExpertId: entity.seniorCommodityExpertId.value ? entity.seniorCommodityExpertId.value : entity.seniorCommodityExpertId,
      goodsSpecialistsIds: entity.goodsSpecialistsIds ? entity.goodsSpecialistsIds.map((i) => i?.value) :
      entity.goodsSpecialists ? entity.goodsSpecialists.map((i) => i?.id) : null,
    };
    if (this.props.successFeatures['cashbox.mobile']) {
      data.mobilePhone = entity.mobilePhone === '+375 __ ___ __ __' ? '' : entity.mobilePhone
    }
    this.setState({
      loading: true,
      error: null,
    })
    let cashBoxId = this.props.match.params.id;
    cashBoxService.updateCashBox(cashBoxId, data).then((response) => {
      if (onSuccess) {
        onSuccess(response);
      }
    }).catch(error => {
      if (error.response) {
        let errorData = error.response.data;
        let commonError = messages["0"];
        if (errorData.errorCode) {
          commonError = messages[errorData.errorCode];
        }
        this.setState({
          error: commonError
        })
      }
    }).finally(() => {
      this.setState({
        loading: false
      })
    });
  }

  onCashBoxEdit(entity) {
    this.updateCashBox(entity, (response) => {
      this.changeModalState("showModalDepartmentEdit", false)
      this.setState({
        cashBox: response.data.cashBox,
        loading: false
      })
      this.loadCashBox(!this.state.inactiveCheck)
    });
  }

  changeCashBoxState() {
    let cashBox = this.state.cashBox;
    this.updateCashBox({
      ...cashBox,
      active: !cashBox.active
    }, () => {
      cashBox.active = !cashBox.active;
      this.setState({
        cashBox: cashBox,
        loading: false
      })
    });
  }

  handleChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.id;

    this.setState({
      [name]: value
    });
  }


  handleInactiveCheck(event) {
    const val = event.target.checked;
    this.setState({
      inactiveCheck: val
    })
    this.loadCashBox(!val);
  }

  handleCouponChange() {
    this.loadCashBox(!this.state.inactiveCheck);
  }

  handleOnAllCouponCheck() {
    let coupons = this.state.cashBox.coupons
    let flag = this.state.allChecked;
    coupons.forEach(cashBox => {
      cashBox.checked = !flag;
    })
    this.setState({
      cashBoxes: this.state.cashBox,
      allChecked: !flag
    })
  }

  handleOnCouponCheck(event) {
    let coupons = this.state.cashBox.coupons
    coupons.forEach(coupon => {
      if (coupon.id === parseInt(event.target.id)) {
        coupon.checked = event.target.checked;
      }
    })
    this.setState({ cashBox: this.state.cashBox })
  }

  handleActivate(checkedCoupons) {
    let ids = checkedCoupons.map(c => c.id);
    this.setState({
      loading: true,
      error: null
    })
    this.changeCoupons(cashBoxService.activateCoupons(ids, !checkedCoupons[0].active));
  }

  handleDelete(checkedCoupons) {
    let ids = checkedCoupons.map(c => c.id);
    this.setState({
      loading: true,
      error: null
    })
    this.changeCoupons(cashBoxService.deleteCoupons(ids));
  }

  changeCoupons(promise) {
    promise.then(() => {
      this.loadCashBox(!this.state.inactiveCheck);
    })
      .catch(error => {
        if (error.response) {
          let errorData = error.response.data;
          let commonError = messages["0"];
          if (errorData.errorCode) {
            commonError = messages[errorData.errorCode];
          }
          this.setState({
            error: commonError
          })
        }
      }).finally(() => {
        this.setState({
          loading: false
        })
      });
  }


  render() {
    let cashBox = this.state.cashBox;
    if (!cashBox) {
      return null;
    }
    let address = `${cashBox.city ? `${cashBox.city}` : ''},  ${cashBox.street}, д. ${cashBox.house}, ${cashBox.building ? 'к. ' + cashBox.building + "," : ''} каб. ${cashBox.office}`;
    let checkedCoupons = this.state.cashBox.coupons.filter(coupon => coupon.checked);
    const isCopyButtonRender = cashBox.coupons && cashBox.coupons.length > 0

    if (cashBox.leader) {
      cashBox.leaderId = cashBox.leader.id;
    }
    if (cashBox.chiefAccountant) {
      cashBox.chiefAccountantId = cashBox.chiefAccountant.id;
    }
    if (cashBox.accountant) {
      cashBox.accountantId = cashBox.accountant.id;
    }
    if (cashBox.seniorCommodityExpert) {
      cashBox.seniorCommodityExpertId = cashBox.seniorCommodityExpert.id;
    }

    let allCheckedSameStatus = true;

    if (checkedCoupons && checkedCoupons.length > 0) {
      let previous = checkedCoupons[0].active;
      checkedCoupons.forEach(c => {
        if (c.active !== previous) {
          allCheckedSameStatus = false;
        }
      })
    }

    return (
        <div className="content-inner-data-container">
          {
            this.state.loading ? <DepartmentEditLoader/> :
            <>
              <fieldset>
                <div className="content-section-title">
                  <div className="content-section-title-actionitems">
                    <h2><big><strong>{cashBox.name}</strong></big> {address}</h2>
                    {cashBox.active ? <CustomDropdown triggerText={"Закрыть подразделение"}
                                                      additionalClasses={"flex-shrink-0"}
                                                      headText={"Вы уверены что хотите закрыть подразделение?"}
                                                      onAction={this.changeCashBoxState}
                                                      buttonText={"Закрыть"}>
                        <LockIcon />
                      </CustomDropdown> :
                      <CustomDropdown triggerText={"Открыть подразделение"}
                                      additionalClasses={"flex-shrink-0"}
                                      headText={"Вы уверены что хотите открыть подразделение?"}
                                      onAction={this.changeCashBoxState}
                                      buttonText={"Открыть"}>
                        <LockIcon />
                      </CustomDropdown>
                    }
                  </div>
                </div>
              </fieldset>
              <Tabs defaultIndex={this.state.tabIndex} onSelect={this.selectTab}>
                <TabList className="content-tabs offset">
                  <Tab className="button-tab" selectedClassName="active">Купоны</Tab>
                  {this.hasAnnuityFeature() && 
                    <Tab className="button-tab" selectedClassName="active">Купоны аннуитет</Tab>}
                  <Tab className="button-tab" selectedClassName="active">Информация</Tab>
                </TabList>
                  <TabPanel>
                    <CouponsTabPanel
                        cashBox={cashBox}
                        checkedCoupons={checkedCoupons}
                        allCheckedSameStatus={allCheckedSameStatus}
                        isCopyButtonRender={isCopyButtonRender}
                        showModalCouponEdit={this.state.showModalCouponEdit}
                        showModalCouponCopy={this.state.showModalCouponCopy}
                        showModalCouponAdd={this.state.showModalCouponAdd}
                        modalMode={this.state.modalMode}
                        inactiveCheck={this.state.inactiveCheck}
                        allChecked={this.state.allChecked}
                        changeModalState={this.changeModalState}
                        handleCouponChange={this.handleCouponChange}
                        handleActivate={this.handleActivate}
                        handleDelete={this.handleDelete}
                        handleInactiveCheck={this.handleInactiveCheck}
                        handleOnAllCouponCheck={this.handleOnAllCouponCheck}
                        handleOnCouponCheck={this.handleOnCouponCheck}
                    />
                  </TabPanel>
                {this.hasAnnuityFeature() && <TabPanel>
                  <CouponsTabPanel
                      cashBox={cashBox}
                      checkedCoupons={checkedCoupons}
                      allCheckedSameStatus={allCheckedSameStatus}
                      isCopyButtonRender={isCopyButtonRender}
                      showModalCouponEdit={this.state.showModalCouponEdit}
                      showModalCouponCopy={this.state.showModalCouponCopy}
                      showModalCouponAdd={this.state.showModalCouponAdd}
                      modalMode={this.state.modalMode}
                      inactiveCheck={this.state.inactiveCheck}
                      allChecked={this.state.allChecked}
                      changeModalState={this.changeModalState}
                      handleCouponChange={this.handleCouponChange}
                      handleActivate={this.handleActivate}
                      handleDelete={this.handleDelete}
                      handleInactiveCheck={this.handleInactiveCheck}
                      handleOnAllCouponCheck={this.handleOnAllCouponCheck}
                      handleOnCouponCheck={this.handleOnCouponCheck}
                      isAnnuity={this.isAnnuity}
                  />
                </TabPanel>}
                <TabPanel>
                  <DepartmentTabInfo
                      cashBox={cashBox}
                      changeModalState={this.changeModalState}
                      showModalDepartmentEdit={this.state.showModalDepartmentEdit}
                      error={this.state.error}
                      onCashBoxEdit={this.onCashBoxEdit}
                  />
                </TabPanel>
              </Tabs>
            </>
          }
        </div>
    )
  }
}

export default withRouter(DepartmentEdit)
